import { CartProductWQuantity } from 'domain/types';

export const areAllAvailable = (products: CartProductWQuantity[]) =>
  products.every(({ available, quantity }) => available && quantity <= available);
